import { useState } from "react";
import { Clapperboard } from "lucide-react";

export const MediaImg = ({ src, alt = "", className = "" }) => {
  const [err, setErr] = useState(false);
  if (err) {
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-ink via-night to-ink ${className}`}
        role="img"
        aria-label={alt}
      >
        <Clapperboard className="h-8 w-8 text-gold/50" />
      </div>
    );
  }
  return <img src={src} alt={alt} loading="lazy" onError={() => setErr(true)} className={className} />;
};
